import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const FinlandLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'FI',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Finland',
  SHORT_NAME: 'FI',

  DISPLAY_NAME: 'Finland (English)',
  DISPLAY_COUNTRY: 'Finland (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 64.4191061,
    INITIAL_LONGITUDE: 15.3822629,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Åland',
    '2': 'Central Finland',
    '3': 'Central Ostrobothnia',
    '4': 'Kainuu',
    '5': 'Kymenlaakso',
    '6': 'Lapland',
    '7': 'North Karelia',
    '8': 'North Ostrobothnia',
    '9': 'North Savo',
    '10': 'Ostrobothnia',
    '11': 'Päijät-Häme',
    '12': 'Pirkanmaa',
    '13': 'Satakunta',
    '14': 'South Karelia',
    '15': 'South Ostrobothnia',
    '16': 'South Savo',
    '17': 'Southwest Finland',
    '18': 'Tavastia Proper',
    '19': 'Uusimaa',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-fi/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-fi/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default FinlandLocale
